import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const ListWrapper = styled(TransitionGroup)(() =>
  mq({
    width: '100%',
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(3, 1fr)',
      'repeat(3, 1fr)',
    ],
    gridGap: defaultTheme.spacing.l,
  }),
);

export const ProgramInfo = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    marginBottom: defaultTheme.spacing.s,
  }),
);

export const List = styled.li(() =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.xxl,
  }),
);

export const LogoArea = styled.div(() =>
  mq({
    display: 'grid',
    gridGap: defaultTheme.spacing.s,
  }),
);

export const Logos = styled.div(() =>
  mq({
    display: 'flex',
    flexWrap: 'wrap',
    '& > img:not(:last-of-type)': {
      marginRight: defaultTheme.spacing.s,
    },
  }),
);

export const ResultArea = styled.div(() =>
  mq({
    marginTop: defaultTheme.spacing.s,
  }),
);

const linkStyle = {
  display: 'block',
  width: '100%',
  fontSize: defaultTheme.font.size.s,
  textAlign: 'center',
  border: `1px solid ${defaultTheme.border.color.black}`,
  borderRadius: defaultTheme.border.radius.s,
  padding: `${defaultTheme.spacing.m} 0`,
  marginTop: defaultTheme.spacing.l,
};

export const StyledLink = styled(Link)(() =>
  mq({
    ...linkStyle,
    ...hoverOpacity,
  }),
);

export const DisabledLink = styled.div(() =>
  mq({
    ...linkStyle,
    opacity: 0.3,
  }),
);
